module.exports = __webpack_public_path__ + "img/banner.29536fbd.jpg";